module.exports = __webpack_public_path__ + "static/img/environment.58d2200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/environment.png
// module id = jzvB
// module chunks = 0